var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.301,
    height: 23.263,
    viewBox: "0 0 23.301 23.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pencil-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3,
    height: 23.263,
    transform: "translate(-1 -2)",
    fill: "#142e38"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    clipPath: "url(#pencil-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.84,13.661l-.468,4.23,4.23-.467L17.688,5.337a1.022,1.022,0,0,0,0-1.428l-2.33-2.33a1.022,1.022,0,0,0-1.428,0Zm-1.194,5.6a.654.654,0,0,1-.481-.211.657.657,0,0,1-.161-.5L.582,13.3a.648.648,0,0,1,.184-.384L13.019.675a2.281,2.281,0,0,1,3.24,0l2.365,2.331a2.281,2.281,0,0,1,0,3.24L6.347,18.494a.647.647,0,0,1-.384.183l-5.247.586Z",
    transform: "translate(0)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.254,8.554a.635.635,0,0,1-.452-.187L13.134,3.7l0,0a.649.649,0,1,1,.93-.907l4.642,4.642a.64.64,0,0,1,0,.907.656.656,0,0,1-.455.211",
    transform: "translate(-1.863 -0.374)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.243,
    height: 1.286,
    transform: "translate(5.438 12.919) rotate(-45.004)",
    fill: "#142e38"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.d7ee7330a3f8366dbb4b55903edbc283.svg";
export { ForwardRef as ReactComponent };